module.exports = __webpack_public_path__ + "static/media/17_4.c2d7bb7b.jpg";